import { actions } from "react-redux-form";
import { TRANSLATIONS } from "../../../utils/constant.utils";
export const formValidationAction = {
    emailValidation: (model,value)=>(dispatch,state)=>{
        let locale = state().translation.locale;
        if (locale === null || locale === '')
            locale = TRANSLATIONS['defaultLocaleLanguage'];

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(value && !emailRegex.test(value)) {
            dispatch(actions.setErrors("orderDetailsForm.localContactEmail", TRANSLATIONS[locale]["invalid_email_address"]));
        }         
    }
}